// Utilities
import { make } from 'vuex-pathify'

// Globals
// import { IN_BROWSER } from '@/util/globals'

const state = {
  loggedIn: false,
  user: {},
  twoFactorEnabled: false,
  twoFactorVerified: false,
}

const mutations = make.mutations(state)

const actions = {
  logout: ({ state }) => {
    state.loggedIn = false
    state.twoFactorEnabled = false
    state.twoFactorVerified = false
    state.user = {}
  },
  // init: ({ state, user }) => {
  //   // const user = JSON.parse(localStorage.getItem('user'))
  //   state.details = user
  // },
}

const getters = {
  twoFactorCheck: state => {
    return !state.twoFactorEnabled ? true : state.twoFactorVerified
  },
  // details: state => {
  //   return state.details
  // },
  loggedIn: state => {
    return state.loggedIn
  },
  adminMode: state => {
    if (state.loggedIn) {
      const perms = state.user.permissions
      return perms.length > 0
    } else {
      return false
    }
  },
  canEditUsers: state => {
    if (state.loggedIn) {
      let perms = state.user.permissions.map(a => a.name)
      return perms.includes('edit_users')
    } else {
      return false
    }
  },
  canEditSettings: state => {
    if (state.loggedIn) {
      let perms = state.user.permissions.map(a => a.name)
      return perms.includes('edit_settings')
    } else {
      return false
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
